import { progressiveVanillaSelector } from '../selectors';
import type { Site } from '../Site';

export const MyImperfectLife: Site = {
  id: 'myimperfectlife',
  logo: 'svg/myimperfectlife.svg',
  label: 'My Imperfect Life',
  analyticsName: 'myimperfectlife',
  hostname: 'myimperfectlife.com',
  platform: 'progressive',
  selector: progressiveVanillaSelector,
};
